export class ColorService {
	private colorsId: { colorId: string, color: string }[] = [];

	public randomColor(colorId: string): string {
		const generateRandomValue = () => Math.floor(250 * Math.random());

		const existingColor = this.colorsId.find((elt) => elt.colorId === colorId);

		if (existingColor) {
			return existingColor.color;
		}

		const color = `rgb(${generateRandomValue()}, ${generateRandomValue()}, ${generateRandomValue()})`;

		this.colorsId.push({
			colorId,
			color
		});

		return color;
	}

	/**
	 * Convertit une couleur hexadécimale en RGBA
	 * @param hex - La couleur hexadécimale à convertir
	 * @param opacity - L'opacité de la couleur
	 * @returns La couleur RGBA
	 */
	public hexToRgba(hex: string, opacity: number): string {
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);
		
		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}
}

export const ColorServiceInstance = new ColorService();



// WEBPACK FOOTER //
// ./src/shared/services/color.service.ts